export default {"src":"/_next/static/media/tick.5f05ce10.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};